import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router';
import { ArrowLeftCircleIcon } from '@heroicons/react/24/outline';
import OnlineStatus from '@medflex/components/stories/OnlineStatus';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import useAddressBookContacts from '../../hooks/useAddressBookContacts';
import useOnlineStatus from '../../hooks/useOnlineStatus';

const ContactOverviewTitleBar = () => {
  const history = useHistory();
  const { contactId } = useParams();
  const { onlineUserIds } = useOnlineStatus();
  const { findOneAddressBookContactByContactId } = useAddressBookContacts();
  const contact = findOneAddressBookContactByContactId(contactId);
  const isOnline = onlineUserIds.includes(contact?.user.id);

  const handleBackToAddressbook = useCallback(
    event => {
      event.preventDefault();
      history.push('/address-book');
    },
    [history],
  );

  if (!contact) return null;

  return (
    <div className="flex items-center py-4">
      <button
        type="button"
        className="text-slate-500 xl:hidden"
        onClick={handleBackToAddressbook}
        aria-label="Back to address book"
      >
        <ArrowLeftCircleIcon className="w-8 h-8" />
      </button>
      <div className="flex items-center w-full justify-center space-x-2">
        {isOnline && <OnlineStatus />}
        <div className="leading-tight min-w-0 py-1">
          <div className="truncate max-w-72 font-semibold">
            {getFullNameWithTitle(contact.user)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactOverviewTitleBar;
